import type { NumColor } from '@/api/groups-matrix'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Num: FunctionalComponent<{
  class?: string
  size?: 's' | 'm' | 'l'
  color?: NumColor
}> = props => {
  return (
    <span
      class={classNames(
        styles.root,
        styles[props.color ?? 'default'],
        styles[props.size ?? 'm'],
        props.class,
      )}
    >
      {props.children}
    </span>
  )
}
